"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The KurslisteItem model module.
 * @module model/KurslisteItem
 * @version 1.0.44
 */
var KurslisteItem = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>KurslisteItem</code>.
   * Ein Eintarg in der Kursliste für Edelmetalle oder Sorten
   * @alias module:model/KurslisteItem
   * @param kennziffer {Number} Kennziffer des Produkts
   * @param bezeichnung {String} Name des Produkts
   * @param betragAK {Number} Betrag im Ankauf des Mitarbeitershops
   */
  function KurslisteItem(kennziffer, bezeichnung, betragAK) {
    _classCallCheck(this, KurslisteItem);
    KurslisteItem.initialize(this, kennziffer, bezeichnung, betragAK);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(KurslisteItem, null, [{
    key: "initialize",
    value: function initialize(obj, kennziffer, bezeichnung, betragAK) {
      obj['kennziffer'] = kennziffer;
      obj['bezeichnung'] = bezeichnung;
      obj['betragAK'] = betragAK;
    }

    /**
     * Constructs a <code>KurslisteItem</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/KurslisteItem} obj Optional instance to populate.
     * @return {module:model/KurslisteItem} The populated <code>KurslisteItem</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new KurslisteItem();
        if (data.hasOwnProperty('kennziffer')) {
          obj['kennziffer'] = _ApiClient.default.convertToType(data['kennziffer'], 'Number');
        }
        if (data.hasOwnProperty('bezeichnung')) {
          obj['bezeichnung'] = _ApiClient.default.convertToType(data['bezeichnung'], 'String');
        }
        if (data.hasOwnProperty('betragAK')) {
          obj['betragAK'] = _ApiClient.default.convertToType(data['betragAK'], 'Number');
        }
        if (data.hasOwnProperty('betragVK')) {
          obj['betragVK'] = _ApiClient.default.convertToType(data['betragVK'], 'Number');
        }
        if (data.hasOwnProperty('betragMaKondAK')) {
          obj['betragMaKondAK'] = _ApiClient.default.convertToType(data['betragMaKondAK'], 'Number');
        }
        if (data.hasOwnProperty('betragMaKondVK')) {
          obj['betragMaKondVK'] = _ApiClient.default.convertToType(data['betragMaKondVK'], 'Number');
        }
        if (data.hasOwnProperty('betragEndkundeVK')) {
          obj['betragEndkundeVK'] = _ApiClient.default.convertToType(data['betragEndkundeVK'], 'Number');
        }
        if (data.hasOwnProperty('kind')) {
          obj['kind'] = _ApiClient.default.convertToType(data['kind'], 'String');
        }
        if (data.hasOwnProperty('make')) {
          obj['make'] = _ApiClient.default.convertToType(data['make'], 'String');
        }
        if (data.hasOwnProperty('isoCode')) {
          obj['isoCode'] = _ApiClient.default.convertToType(data['isoCode'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>KurslisteItem</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>KurslisteItem</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(KurslisteItem.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // ensure the json data is a string
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['bezeichnung'] && !(typeof data['bezeichnung'] === 'string' || data['bezeichnung'] instanceof String)) {
        throw new Error("Expected the field `bezeichnung` to be a primitive type in the JSON string but got " + data['bezeichnung']);
      }
      // ensure the json data is a string
      if (data['kind'] && !(typeof data['kind'] === 'string' || data['kind'] instanceof String)) {
        throw new Error("Expected the field `kind` to be a primitive type in the JSON string but got " + data['kind']);
      }
      // ensure the json data is a string
      if (data['make'] && !(typeof data['make'] === 'string' || data['make'] instanceof String)) {
        throw new Error("Expected the field `make` to be a primitive type in the JSON string but got " + data['make']);
      }
      // ensure the json data is a string
      if (data['isoCode'] && !(typeof data['isoCode'] === 'string' || data['isoCode'] instanceof String)) {
        throw new Error("Expected the field `isoCode` to be a primitive type in the JSON string but got " + data['isoCode']);
      }
      return true;
    }
  }]);
}();
KurslisteItem.RequiredProperties = ["kennziffer", "bezeichnung", "betragAK"];

/**
 * Kennziffer des Produkts
 * @member {Number} kennziffer
 */
KurslisteItem.prototype['kennziffer'] = undefined;

/**
 * Name des Produkts
 * @member {String} bezeichnung
 */
KurslisteItem.prototype['bezeichnung'] = undefined;

/**
 * Betrag im Ankauf des Mitarbeitershops
 * @member {Number} betragAK
 */
KurslisteItem.prototype['betragAK'] = undefined;

/**
 * Betrag im Verkauf des Mitarbeitershops
 * @member {Number} betragVK
 */
KurslisteItem.prototype['betragVK'] = undefined;

/**
 * Mitarbeiterkondition im Ankauf des Mitarbeitershops
 * @member {Number} betragMaKondAK
 */
KurslisteItem.prototype['betragMaKondAK'] = undefined;

/**
 * Mitarbeiterkondition im Verkauf des Mitarbeitershops
 * @member {Number} betragMaKondVK
 */
KurslisteItem.prototype['betragMaKondVK'] = undefined;

/**
 * Preis im Kundenshop Verkauf
 * @member {Number} betragEndkundeVK
 */
KurslisteItem.prototype['betragEndkundeVK'] = undefined;

/**
 * Art bei Edelmetall
 * @member {module:model/KurslisteItem.KindEnum} kind
 */
KurslisteItem.prototype['kind'] = undefined;

/**
 * Ausführung, z.B. coin für Münzen
 * @member {module:model/KurslisteItem.MakeEnum} make
 */
KurslisteItem.prototype['make'] = undefined;

/**
 * Bei Sorten der 3 stellige ISO code
 * @member {String} isoCode
 */
KurslisteItem.prototype['isoCode'] = undefined;

/**
 * Allowed values for the <code>kind</code> property.
 * @enum {String}
 * @readonly
 */
KurslisteItem['KindEnum'] = {
  /**
   * value: "gold"
   * @const
   */
  "gold": "gold",
  /**
   * value: "silver"
   * @const
   */
  "silver": "silver",
  /**
   * value: "platinum"
   * @const
   */
  "platinum": "platinum",
  /**
   * value: "palladium"
   * @const
   */
  "palladium": "palladium",
  /**
   * value: "other"
   * @const
   */
  "other": "other"
};

/**
 * Allowed values for the <code>make</code> property.
 * @enum {String}
 * @readonly
 */
KurslisteItem['MakeEnum'] = {
  /**
   * value: "coin"
   * @const
   */
  "coin": "coin",
  /**
   * value: "ingot"
   * @const
   */
  "ingot": "ingot",
  /**
   * value: "casket"
   * @const
   */
  "casket": "casket",
  /**
   * value: "accessory"
   * @const
   */
  "accessory": "accessory"
};
var _default = exports.default = KurslisteItem;